import { BrowserRouter, Routes, Route } from "react-router-dom"
import { UserAuthProvider } from "./context/UserAuthContext"
import { ProtectedRoute } from "./components/auth/ProtectedRoute"
import { AdminLayout } from "./pages/admin/AdminLayout"
import DomainsPage from "./pages/admin/Domains"
import JobsPage from "./pages/admin/JobsList"
import ViewJobComponent from "./pages/admin/ViewJob"
import LoginPage from "./pages/auth/AdminLogin"
import JobListPage from "./pages/candidate/jobLists"
import AddJobComponent from "./pages/admin/CreateJob"
import NotFound from "./pages/NotFound"
import Landing from "./pages/Landing"
import JobDetailPage from "./pages/candidate/JobDetail"
import AboutPage from "./pages/About"
import ContactPage from "./pages/Contact"


function App() {
  return (
    <UserAuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="" element={<Landing />} />
          <Route
            path="/admin/*"
            element={
              <ProtectedRoute requiredRole="ADMIN">
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route path="domains" element={<DomainsPage />} />
            <Route path="create-job" element={<AddJobComponent />} />
            <Route path="view-job/:id" element={<ViewJobComponent />} />
            <Route path="jobs" element={<JobsPage />} />
          </Route>

          <Route path="/jobs" element={<JobListPage />} />
          <Route path="/jobs/:id" element={<JobDetailPage />} />

          {/* General Pages */}
          <Route path="/about" element={<AboutPage />} />
          <Route path="/contact" element={<ContactPage />} />

          {/* Public Route */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </UserAuthProvider>
  )
}

export default App
